export default __webpack_public_path__ + "static/media/mardi.a1ee7ad5.jpg";